import React from '../../../_snowpack/pkg/react.js';
import { useHistory, useLocation } from '../../../_snowpack/pkg/react-router-dom.js'; //@ts-ignore

import { Button } from '../../css/index.js';
import NotFoundIllustration from '../../images/illustrations/horse-giving-boss-a-bath.png';
import { Saying, Wrapper } from './styles.js';

function NotFound404() {
  const history = useHistory();
  const location = useLocation();
  const basePath = location.pathname.replace(/\//g, ' ').trim().split(' ')[0];

  const handleButtonClick = event => {
    event.stopPropagation();
    const isPathValid = ['catalogue', 'fulfilment', 'catalogue-explorer', 'grids', 'orders', 'settings', 'shapes', 'topics', 'webhooks'].includes(basePath);
    history.replace(isPathValid ? `/${basePath}` : `/`);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-cypress": "404-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: NotFoundIllustration,
    alt: "Path not found illustration",
    "data-cypress": "404-illustration"
  }), /*#__PURE__*/React.createElement(Saying, null, /*#__PURE__*/React.createElement("h2", null, "Somehow, you took the wrong path"), /*#__PURE__*/React.createElement("p", null, "You should not be here!"), /*#__PURE__*/React.createElement(Button, {
    primary: true,
    onClick: handleButtonClick,
    "data-cypress": "404-button"
  }, "Get me out of here!")));
}

export default NotFound404;